import React from "react";

import { Box, Flex, Text } from "src/components";

const Section = ({
  title,
  Icon,
  renderComponentRight,
  children,
  isAlt = false,
  sideBySide = false,
  ...styleProps
}) => (
  <Flex
    bg={isAlt ? "insetBackground" : undefined}
    pt={3}
    pb={3}
    px={3}
    flexDirection={sideBySide ? "row" : "column"}
    align={sideBySide ? "flex-start" : undefined}
    {...styleProps}
  >
    <Flex align="center" flexDirection={["column", "row"]}>
      <Flex flex={3}>
        <Text color="blue" mr={2}>
          <Icon size={22} />
        </Text>
        <Text fontSize={4} color="blue">
          {title.toUpperCase()}
        </Text>
      </Flex>
      {renderComponentRight ? (
        <Flex flex={2} mt={[2, 0]}>
          {renderComponentRight()}
        </Flex>
      ) : null}
    </Flex>

    <Box mt={sideBySide ? 0 : 2} flex={sideBySide ? 1 : undefined}>
      {children}
    </Box>
  </Flex>
);

export default Section;



// WEBPACK FOOTER //
// ./src/banking/components/Section.js